import { useEffect, useState } from "react";
import CreateUMOModal from "../components/CreateUMOModal";
import { getDateToday, getUser } from "../../../../Utils/externalFunctions";
import EditUMOModal from "../components/EditUMOModal";
import useAxios from "../../../../Utils/useAxios";
import { STATUS_DATA_TYPE } from "../../../../Constant/StatusData";
import SubHeaderComponent from "../../../DataTableComponents/commonSubHeaderComponent";
import {
  filterEqualToDate,
  filterSearch,
  filterStatus,
} from "../../../../Utils/FilterItems";
import { useThemeContext } from "../../../../Context/ThemeContext";
import FeatureContainer from "../../../../Layout/Containers/FeatureContainer";
import CreateButton from "../../../../CommonElements/Button/CreateButton";
import { FEATURE_FUNCTION_SELECTION } from "../../../../Constant/FeatureSelection";
import ListUMO from "../components/ListUMO";
import DeleteUMOModal from "../components/DeleteUMOModal";
import getUMOColumns from "../constants/getUMOColumns";
import { getUMO, getUnitKerja } from "../services";
import { Button } from "reactstrap";
import ExportUMO from "../components/ExportUMO";
import { admins, timeToast } from "../../../../Constant";
import getUMOCheck from "../services/getUMOCheck";
import { toast } from "react-toastify";

const UangMukaOperasionalContain = () => {
  const axiosInstance = useAxios();
  const isAdmin = admins.includes(getUser());

  const [UMOList, setUMOList] = useState([]);
  const [unitKerja, setUnitKerja] = useState([]);

  const [pending, setPending] = useState({
    umo: false,
    status: false,
  });
  const [totalUMO, setTotalUMO] = useState(0);

  const [filterText, setFilterText] = useState("");
  const [selectedStatusUM, setSelectedStatusUM] = useState("");
  const [selectedFilterUnitKerja, setSelectedFilterUnitKerja] = useState("");
  const [selectedFilterTanggal, setSelectedFilterTanggal] = useState("");
  const [selectedUMO, setSelectedUMO] = useState(null);

  const [applyDateFilter, setApplyDateFilter] = useState(true);
  const toggleDateFilter = () => {
    setApplyDateFilter(!applyDateFilter);
  };

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const toggleEditModal = () => setEditModalOpen(!editModalOpen);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen);
  
  const { themeContext } = useThemeContext();

  const toggleCreateModal = async () => {
    try {
      const eligible = await getUMOCheck(axiosInstance); 
      if (eligible.status === 200) {
        toast.error(`Selesaikan Pertanggungjawaban Pengajuan Terkahir`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: timeToast,
        });
      } else if (eligible.status === 204) {
        setCreateModalOpen(!createModalOpen);
      }
    } catch (error) {
      console.error("Error checking UMO eligibility:", error);
    }
  };

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      await refreshUMO();

      const { data: unitKerjaData } = await getUnitKerja(axiosInstance);
      setUnitKerja(unitKerjaData);
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const filteredUMO = filterUMOItems(UMOList);
    let total = 0;
    filteredUMO.forEach((item) => {
      total += parseFloat(item.nilai);
    });
    setTotalUMO(total);
  }, [filterUMOItems, toggleDateFilter]);

  const refreshUMO = async () => {
    setPending((prev) => ({
      ...prev,
      umo: true,
      status: true,
    }));

    const { data: umoData } = await getUMO(axiosInstance).finally(() =>
      setPending((prev) => ({ ...prev, umo: false, status: false }))
    );
    setUMOList(umoData);
    return umoData;
  };

  const handleEditUMO = (umo) => {
    setSelectedUMO(umo);
    toggleEditModal();
  };

  const handleDeleteUMO = (umo) => {
    setSelectedUMO(umo);
    toggleDeleteModal();
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const filterUMOItems = (items) => {
    const searchCategories = [
      "diajukan_oleh",
      "id_unit_kerja",
      "kode_umo",
      "keterangan",
    ];
    const filteredItems = items
      .filter(filterSearch(searchCategories, filterText))
      .filter(filterStatus("id_status_umo", selectedStatusUM))
      .filter(filterSearch(["id_unit_kerja"], selectedFilterUnitKerja))
      .filter(filterEqualToDate("untuk_tanggal", selectedFilterTanggal))
      .filter(filterTanggalToday);

    return filteredItems;
  };
  const filterTanggalToday = (item) => {
    const todayDate = getDateToday("original");
    return applyDateFilter
      ? item.untuk_tanggal === todayDate && item.id_status_umo === 1
      : item;
  };

  const subHeaderComponent = (
    <SubHeaderComponent
      filterText={filterText}
      setFilterText={setFilterText}
      handleClear={handleClear}
      setSelectedStatus={setSelectedStatusUM}
      setSelectedFilterUnitKerja={setSelectedFilterUnitKerja}
      setSelectedFilterTanggal={setSelectedFilterTanggal}
      unitKerja={unitKerja}
      statusDataType={STATUS_DATA_TYPE.UMO}
    />
  );

  return (
    <FeatureContainer
      title={"Uang Muka Operasional"}
      statusList={filterUMOItems(UMOList)}
      pending={pending?.status}
      refreshList={refreshUMO}
      createButton={
        <>
          {FEATURE_FUNCTION_SELECTION.UMO.Create && (
            <CreateButton toggle={toggleCreateModal}>
              Buat Operasional
            </CreateButton>
          )}
          {
            isAdmin && (
              <ExportUMO />
            )
          }
        </>
      }
    >
      <ListUMO
        data={filterUMOItems(UMOList)}
        columns={getUMOColumns({
          themeContext,
          handleEditUMO,
          handleDeleteUMO,
        })}
        totalUMO={totalUMO}
        subHeaderComponent={subHeaderComponent}
        pending={pending?.umo}
        applyDateFilter={applyDateFilter}
        toggleDateFilter={toggleDateFilter}
        resetPaginationToggle={resetPaginationToggle}
      />
      <CreateUMOModal
        refreshUMO={refreshUMO}
        unitKerja={unitKerja}
        modal={createModalOpen}
        toggle={toggleCreateModal}
        UMOList={UMOList}
      />
      {selectedUMO && (
        <EditUMOModal
          editModalOpen={editModalOpen}
          toggleEditModal={toggleEditModal}
          selectedUMO={selectedUMO}
          refreshUMO={refreshUMO}
          unitKerja={unitKerja}
        />
      )}
      {selectedUMO && (
        <DeleteUMOModal
          deleteModalOpen={deleteModalOpen}
          toggleDeleteModal={toggleDeleteModal}
          selectedUMO={selectedUMO}
          refreshUMO={refreshUMO}
        />
      )}
    </FeatureContainer>
  );
};

export default UangMukaOperasionalContain;
